// extracted by mini-css-extract-plugin
export default {"attachmentImages":"DealDetails_attachmentImages__XMAZI","attachmentFiles":"DealDetails_attachmentFiles__7TdSZ"};